import axiosInstance from "@/api/axios-instance";

// Returns true if the slug is free (no existing payment page uses it).
export async function checkSlugAvailability(slug: string): Promise<boolean> {
  const response = await axiosInstance.get("/payment-pages/slug-availability", {
    params: { slug },
  });
  return Boolean(response.data?.available);
}
